export default "__VITE_ASSET__7HDOaOkB__"